import { generateFormItemName } from ".";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-shared/uikit/Form";
import { Accordion } from "@circle-react-uikit/Accordion";
import type { FlattenedCssVariables } from "../index";
import { ButtonSliderControl } from "./ButtonSliderControl";
import type { ButtonType, ButtonVariant } from "./index";

interface BorderProps {
  buttonType: ButtonType;
  buttonVariant: ButtonVariant;
  customColors: Record<string, string>;
  flattenedCssVariables: FlattenedCssVariables;
  onAddCustomColor: (color: string) => void;
  themeColors: FlattenedCssVariables;
}

export const Border = ({
  buttonType,
  buttonVariant,
  flattenedCssVariables,
  themeColors,
  customColors,
  onAddCustomColor,
}: BorderProps) => (
  <div className="px-6 pt-5">
    <Accordion defaultOpen>
      <Accordion.Item
        title={t(
          "builder_ui.theme_configuration.site_styles.button_styles.border",
        )}
      >
        <Form.Item
          hideBorder
          isFirstChild
          hideDescription
          name={generateFormItemName(buttonType, buttonVariant, "border-color")}
          label={t(
            "builder_ui.theme_configuration.site_styles.button_styles.border_opacity_and_color",
          )}
          className="!flex !w-full !items-center !justify-between"
        >
          <Form.ColorPickerV2
            name={generateFormItemName(
              buttonType,
              buttonVariant,
              "border-color",
            )}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
            shouldRenderThemeColors
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={onAddCustomColor}
          />
        </Form.Item>
        <ButtonSliderControl
          name={generateFormItemName(buttonType, buttonVariant, "border-width")}
          label={t(
            "builder_ui.theme_configuration.site_styles.button_styles.border_width",
          )}
        />
      </Accordion.Item>
    </Accordion>
  </div>
);
